import type { MutableRefObject, PropsWithChildren } from "react";
import type { HomeSectionId } from "../../content/siteContent";
import { CanvasRoot } from "../../webgl/CanvasRoot";
import { SiteNavigation } from "./SiteNavigation";

type SiteFrameProps = PropsWithChildren<{
  headerRef: MutableRefObject<HTMLElement | null>;
  navHidden?: boolean;
  onNavigateSection: (id: HomeSectionId) => void;
}>;

export function SiteFrame({ children, headerRef, navHidden = false, onNavigateSection }: SiteFrameProps) {
  return (
    <div className="site-shell">
      <CanvasRoot />
      <div className="site-shell__overlay">
        <SiteNavigation hidden={navHidden} onNavigateSection={onNavigateSection} ref={headerRef} />
        <main className="site-main">{children}</main>
      </div>
    </div>
  );
}
